import React, { ComponentProps } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaThumbsDown } from 'react-icons/fa';

type ButtonProps = React.ComponentProps<typeof Button>;

type Props = ButtonProps & {
  loading?: boolean;
  text?: string;
};
const ButtonReject = ({
  loading = false,
  text = '',
  type = 'button',
  variant = 'danger',
  onClick,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  text = text ? text : t('Reject');
  return (
    <Button {...rest} variant={variant} type={type} onClick={onClick}>
      {loading ? (
        <Spinner animation="border" size="sm" className="mb-1 me-2" />
      ) : (
        <FaThumbsDown className="mb-1 me-2" />
      )}
      {text}
    </Button>
  );
};

export default React.memo(ButtonReject);

